"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectricSlideAbilityHandler = exports.ElectricSlideActorAbilityFactory = exports.ElectricSlideAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ElectricSlideAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElectricSlide;
        this.__typeName = "ElectricSlide";
    }
}
exports.ElectricSlideAbilityArgs = ElectricSlideAbilityArgs;
let ElectricSlideActorAbilityFactory = class ElectricSlideActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElectricSlide", "OneEnemies", 4);
    }
};
ElectricSlideActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElectricSlide")
], ElectricSlideActorAbilityFactory);
exports.ElectricSlideActorAbilityFactory = ElectricSlideActorAbilityFactory;
let ElectricSlideAbilityHandler = class ElectricSlideAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const percentHealth = container.getAttributeScore(selectedEnemy, enums_1.AttributeType.Health)
            / container.getMaxAttributeScore(selectedEnemy, enums_1.AttributeType.Health);
        container.applyProjectileAttackWithDamage({
            sequence,
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            projectileType: "BlueLightningPulse",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", Math.round(100 * percentHealth))
            ],
            onHit: (sequence) => {
                if (percentHealth < 50) {
                    return;
                }
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Ticks(16),
                    effect: new core_1.ConvulsionsEffectArgs("Focus", 10),
                });
            }
        });
    }
};
ElectricSlideAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElectricSlide)
], ElectricSlideAbilityHandler);
exports.ElectricSlideAbilityHandler = ElectricSlideAbilityHandler;
